import React, { useState, useEffect, Fragment } from 'react';
import { MessageOutlined } from '@ant-design/icons';
import { Modal, message } from 'antd';
import { connect } from 'dva';
import Scan from '../scan-wx-qr';

const mapStateToProps = state => ({
  user: state.userInfo.user,
});

const BindWx = ({ user, dispatch }) => {
  const [display, setDisplay] = useState(false);
  const [wxOpenId, setWxopenid] = useState();

  useEffect(() => {
    const { wx_openid } = user;

    wx_openid && setWxopenid(wx_openid);
  }, [user.wx_openid]);

  const bindWx = () => setDisplay(true);

  const bindDone = () => {
    setWxopenid(10);
    dispatch({ type: 'userInfo/updateUser', payload: { wx_openid: 10 } });
    message.success('绑定成功！下次可进行扫码登录', 1.2, () => setDisplay(false));
  };

  return (
    <Fragment>
      {!wxOpenId && (
        <span className="ml-12" onClick={bindWx}>
          <MessageOutlined />
          <span>绑定微信</span>
        </span>
      )}
      <Modal
        title="绑定微信，即可微信接收工作通知"
        visible={display}
        onCancel={() => setDisplay(false)}
        footer={null}
        destroyOnClose
      >
        <Scan callback={bindDone} scanType="bind" />
      </Modal>
    </Fragment>
  );
};

export default connect(mapStateToProps)(BindWx);
